module.exports = __webpack_public_path__ + "01_veryshort_brown.698a8f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_veryshort_brown.png
// module id = vTJW
// module chunks = 0